class CommonUtil {

  /**
   * @author lihh
   * @description 判断是否为空
   * @param {*} content 为空返回false  反之返回true
   */
  _isEmpty(content = '') {

    // 判断是否是数字
    if ( typeof content === 'number' ) {

      return content === 0 ? false : true
    }

    // 判断check内容是否为空
    if ( !content || content.replace(/\s+/gi, '') === '' ) return false
    return true
  }

  /**
   * @author lihh
   * @description 判断是否为null
   */
  _isNull(text) {

    return !text || text == '' || text == 'null'
  }

  /**
   * @author lihh
   * @description 判断手机号是否合法
   * @param {*} content 不合法返回false  反之返回true
   */
  _checkPhone(content = '') {

    // 判断手机号是否合法
    return /^[0-9]{11}$/.test(content)
  }

  /**
   * @author lihh
   * @description 判断邮箱是否正确
   * @param {*} content 邮箱不合法返回false  反之返回true
   */
  _checkEmail(content = '') {

    // 判断邮箱是否合法
    if ( !/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(content) ) return false
    return true
  }

  /**
   * @author lihh
   * @description 判断是否为汉字
   * @param {*} content 不是汉字返回false 反之返回true
   */
  _checkCharacter(content = '') {

    // 判断是否为汉字
    return /[\u4E00-\u9FA5]/ig.test(content)
  }

  /**
   * @author lihh
   * @description 判断是否是数字
   * @param content 如果是返回true  反之返回false
   */
  _isNumber(content) {

    return /^[0-9]*[0-9]$/gi.test(content)
  }

  /**
   * @author lihh
   * @description 为了兼容ie  专门对日期格式化
   */
  _dateFormat(date = new Date()) {

    // 判断是否为字符串 将- 替换为 / 是标准语法 也是为了兼容ie等
    if ( typeof date == 'string' ) {

      // 判断是否是标准日期
      return date = date.indexOf('T') == - 1 ? date.replace(/-/g, '/') : date
    }

    return date
  }

  /**
   * @author lihh
   * @description 日期转换
   */
  _dateChange(date = new Date()) {
    // 判断是否为字符串 将- 替换为 / 是标准语法 也是为了兼容ie等
    if ( typeof date === 'string' ) {

      // 判断是否是标准日期
      date = date.indexOf('T') === - 1 ? new Date(date.replace(/-/g, '/')) : new Date(date)
    }
    let y = date.getFullYear()
    let m = date.getMonth() + 1
    let d = date.getDate()
    let w = date.getDay()
    let h = date.getHours()
    h = h < 10 ? '0' + h : h
    let min = date.getMinutes()
    min = min < 10 ? '0' + min : min
    let s = date.getSeconds()
    s = s < 10 ? '0' + s : s

    return `${ y }-${ m }-${ d } ${ h }:${ min }:${ s }`
  }

  /**
   * @author lihh
   * @description 判断网址是否正确
   * @param {*} content 如果是返回true  反之返回false
   */
  _isHttp(content = '') {

    return /^([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/)(([A-Za-z0-9-~]+)\.)+([A-Za-z0-9-~\/])+$/gi.test(content)
  }

  /**
   * @author lihh
   * @description 修改薪资格式
   * @param {*} item
   */
  _updateMoneyFormat(item) {

    if ( !item.salaryMax ) {
      item['newSalary'] = '面议'
    } else {
      item['newSalary'] = item.salaryType === 1 || item.salaryType === 3
        ? item.salaryMin == item.salaryMax ? `${ item.salaryMax / 1000 }K` : `${ item.salaryMin / 1000 }-${ item.salaryMax / 1000 }K`
        : item.salaryMin == item.salaryMax ? `${ item.salaryMax }元/天` : `${ item.salaryMin }-${ item.salaryMax }元/天`
    }
    return item
  }

  /**
   * @author lihh
   * @description 加载中动画
   */
  _loadding(titles = '') {

    let ele = $('body')
    const base64 = require('@/assets/images/loading.gif')

    // 设置内容
    let html = `
        <div class = 'loadings'>
            <div class = 'loading_shade'>
            </div>
            <div>
                <img src = '${ base64 }' class = 'loading_img' style = 'top: 45%; left: 50%;'>
                <div class = 'load_titles' style = 'top: 40%; left: 48%;'>${ titles }</div>
            </div>
        </div>
      `
    ele.append(html)
  }

  /**
   * @author lihh
   * @description base4位 转换为 blob类型
   * @param {*} base64Data
   */
  _dataURItoBlob(base64Data) {

    let byteString
    if ( base64Data.split(',')[0].indexOf('base64') >= 0 )
      //base64 解码
      byteString = atob(base64Data.split(',')[1])
    else {
      byteString = unescape(base64Data.split(',')[1])
    }
    let mimeString = base64Data.split(',')[0].split(':')[1].split(';')[0]

    //创建视图
    let ia = new Uint8Array(byteString.length)
    for ( let i = 0; i < byteString.length; i ++ ) {
      ia[i] = byteString.charCodeAt(i)
    }
    let blob = new Blob([ ia ], {
      type: mimeString
    })
    return blob
  }

  /**
   * @author lihh
   * @description 删除loadding动画
   */
  _removeLoadding() {

    $('body div.loadings').remove()
  }

  /**
   * @author lihh
   * @description 进行两个数值的比较
   * @param min 最小值
   * @param max 最大值
   */
  _compareContent(min = null, max = null) {

    // 判断是否为空
    if ( !min || min === '' || !max || max == null ) return null

    // 判断是否一致
    if ( min == max ) return min

    return `${ min }-${ max }`
  }

  /**
   * @author lihh
   * @description 生成uuid
   */
  _getuuId() {
    let s = []
    let hexDigits = '0123456789abcdef'
    for ( let i = 0; i < 36; i ++ ) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
    }
    s[14] = '4'  // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)  // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = '-'

    let uuid = s.join('')
    return uuid
  }

  /**
   * @author lihh
   * @description 图片base64位转换
   */
  _imgToBase64(file, maxLen, callBack) {

    // 实例化图片
    let img = new Image()
    // 读取客户端上的文件
    let reader = new FileReader()

    reader.onload = function() {

      // 读取到的文件内容.这个属性只在读取操作完成之后才有效,并且数据的格式取决于读取操作是由哪个方法发起的.所以必须使用reader.onload，
      let url = reader.result
      // reader读取的文件内容是base64,利用这个url就能实现上传前预览图片
      img.src = url
    }

    img.onload = () => {
      //生成比例
      let width = img.width, height = img.height
      //计算缩放比例
      let rate = 1
      if ( width >= height ) {
        if ( width > maxLen ) {
          rate = maxLen / width
        }
      } else {
        if ( height > maxLen ) {
          rate = maxLen / height
        }
      }

      img.width = width * rate
      img.height = height * rate
      // 生成canvas
      let canvas = document.createElement('canvas')
      let ctx = canvas.getContext('2d')
      canvas.width = img.width
      canvas.height = img.height
      ctx.drawImage(img, 0, 0, img.width, img.height)
      let fileSizes = this._showSize(img.src)
      let base64 = canvas.toDataURL('image/png', this._getCompressRate(1, fileSizes))

      // 回调返回base64位
      callBack(base64)
    }
    reader.readAsDataURL(file)
  }

  /**
   * @author lihh
   * @description 根据图片路径生成base64位
   * @param url 表示路径
   * @param callback
   */
  imgPathToBase64(url) {
    return new Promise(resolve => {
      let canvas = document.createElement('canvas'),
        ctx = canvas.getContext('2d'),
        img = new Image
      img.crossOrigin = 'Anonymous'
      img.onload = function() {
        canvas.height = img.height
        canvas.width = img.width
        ctx.drawImage(img, 0, 0)
        let dataURL = canvas.toDataURL('image/png')
        resolve(dataURL)
        canvas = null
      }
      img.src = url
    })
  }

  /**
   * @author lihh
   * @description 将base64位 转换为file文件
   * @param dataurl
   * @param filename
   * @returns {File}
   */
  dataURLtoFile(dataurl, filename) {
    if ( typeof filename === 'undefined' ) {
      filename = + new Date() + '.png'
    }
    let arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n)
    while ( n -- ) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    return new File([ u8arr ], filename, { type: mime })
  }

  /**
   * @author lihh
   * @description 计算压缩比率，size单位为MB
   * @param {*} allowMaxSize
   * @param {*} fileSize
   */
  _getCompressRate(allowMaxSize, fileSize) {
    let compressRate = 1
    if ( fileSize / allowMaxSize > 4 ) {
      compressRate = 0.5
    } else if ( fileSize / allowMaxSize > 3 ) {
      compressRate = 0.6
    } else if ( fileSize / allowMaxSize > 2 ) {
      compressRate = 0.7
    } else if ( fileSize > allowMaxSize ) {
      compressRate = 0.8
    } else {
      compressRate = 0.9
    }
    return compressRate
  }

  /**
   * @author lihh
   * @description url转换
   * @param {*} base64url
   */
  _showSize(base64url) {
    //获取base64图片大小，返回MB数字
    let str = base64url.replace('data:image/png;base64,', '')

    let equalIndex = str.indexOf('=')
    if ( str.indexOf('=') > 0 ) {
      str = str.substring(0, equalIndex)
    }
    let strLength = str.length
    let fileLength = parseInt(strLength - (strLength / 8) * 2)
    // 由字节转换为MB
    let size = ''
    size = (fileLength / (1024 * 1024)).toFixed(2)
    // 转成字符串
    let sizeStr = size + ''
    // 获取小数点处的索引
    let index = sizeStr.indexOf('.')
    // 获取小数点后两位的值
    let dou = sizeStr.substr(index + 1, 2)
    // 判断后两位是否为00，如果是则删除00
    if ( dou == '00' ) {
      return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2)
    }
    return parseInt(size)
  }
}

export default CommonUtil



// WEBPACK FOOTER //
// ./src/assets/js/CommonUtil.js